// infrastructure/mappers/remark.mapper.ts

import { format } from 'date-fns';
import { RemarkData } from '../../domain/RemarksData';
import { CreateRemarkDTO, RemarksDTO } from '../dto/RemarksDTO';

export class RemarkMapper {
  static toDomain(dto: RemarksDTO): RemarkData {
    return new RemarkData(
      Number(dto.id),
      dto.code,
      Number(dto.provider_id),
      dto.provider_tier,
      dto.description,
      dto.provider,
      dto.line,
      dto.issue_reason,
      dto.actions,
      dto.impact_percentage,
      dto.logistics_flow,
      format(new Date(dto.report_date), 'yyy-MM-dd'),
      dto.created_at === null
        ? null
        : format(new Date(dto.created_at), 'yyy-MM-dd:HH:mm:ss'),
      dto.modified_at === null
        ? null
        : format(new Date(dto.modified_at), 'yyy-MM-dd:HH:mm:ss')
    );
  }

  static toDomainList(dtos: RemarksDTO[]): RemarkData[] {
    return dtos.map(this.toDomain);
  }

  static toDomainSIngle(dtos: RemarksDTO): RemarkData {
    return this.toDomain(dtos);
  }

  static toCreateDTO(domain: RemarkData): CreateRemarkDTO {
    return {
      code: domain.code,
      provider_id: domain.provider_id,
      provider_tier: domain.provider_tier,
      description: domain.description,
      provider: domain.provider,
      line: domain.line,
      issue_reason: domain.issueReason,
      actions: domain.actions,
      impact_percentage: domain.impactPercentage,
      logistics_flow: domain.logisticsFlow,
      created_at: domain.createdAt,
      modified_at: domain.modifiedAt
    };
  }

  static toEditDTO(
    domain: RemarkData
  ): Omit<RemarksDTO, 'provider_id' | 'provider_tier'> {
    return {
      id: domain.id,
      code: domain.code,
      description: domain.description,
      provider: domain.provider,
      line: domain.line,
      issue_reason: domain.issueReason,
      actions: domain.actions,
      impact_percentage: domain.impactPercentage,
      logistics_flow: domain.logisticsFlow,
      report_date: domain.reportDate,
      created_at: domain.createdAt,
      modified_at: domain.modifiedAt
    };
  }
}
